import { api } from "./api";
import { AxiosError } from "axios";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export const fetchWishlistData = async (endpoint: string) => {
  try {
    const response = await api.get(endpoint, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error(
        "Error fetching wishlist data:",
        error.response?.data || error.message
      );
    } else {
      console.error("Unexpected error:", error);
    }
    throw new Error("Failed to fetch wishlist data");
  }
};
interface WishlistUpdateRequest {
  customerId: string;
  productId: string;
}

export const updateWishlistData = async (data: WishlistUpdateRequest) => {
  try {
    const response = await api.put("wishlist", data, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error(
        "Error updating wishlist:",
        error.response?.data || error.message
      );
    } else {
      console.error("Unexpected error:", error);
    }
    throw new Error("Failed to update wishlist");
  }
};
